import React, { useState, useRef, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import Circle from "../../Fragments/Circle";
import { groupByKey, applyDrag } from "../../../helpers/index";
import config from "../../../baseConfig/index";
import {
  localStorageSetItem,
  localStorageGetItem,
} from "../../../storage/index";
import { trans, setComoAfterThirdSymbol } from "../../../helpers/index";
import { Container, Draggable } from "react-smooth-dnd";
import ApiManager from "../../../apiManager/index";
import ReactNotification from "react-notifications-component";
import ErrorModal from "../../Fragments/ErrorModal";
import ProductAppList from "../../Fragments/ProductAppList";
import Modal from "../../Fragments/Modal";

function DefaultPage(props) {
  const [customerList, setCustomerList] = useState("");
  const [customerListLabels, setCustomerListLabels] = useState("");
  const [tariffList, setTariffList] = useState("");
  const [inclusionsList, setInclusionsList] = useState("");
  const [productApps, setProductApps] = useState("");

  const [dnd1, setDnd1] = useState(
    localStorageGetItem("profileDefaultDnd1") || [0]
  );
  const [dnd2, setDnd2] = useState(
    localStorageGetItem("profileDefaultDnd2") || [1]
  );
  const [dnd3, setDnd3] = useState(
    localStorageGetItem("profileDefaultDnd3") || [2]
  );

  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showAlertServiceModal, setShowAlertServiceModal] = useState(false);
  const [showConfirmServiceModal, setShowConfirmServiceModal] = useState(false);
  const [confirmActivate, setConfirmActivate] = useState("");
  const [confirmData, setConfirmData] = useState(null);
  const userData = localStorage.getItem("beelineApp");
  const componentIsMounted = useRef(true);

  const language = useMemo(() => {
    return JSON.parse(userData).defaultLngPrefix;
  }, [userData]);

  useEffect(() => {
    return () => {
      componentIsMounted.current = false;
    };
  }, []);

  const notificationDOMRef = useRef(null);

  useEffect(() => {
    initAsyncCalls();
  }, []);

  useEffect(() => {
    if (props.parentState.switchAccount) {
      setTariffList("");
      setInclusionsList("");
      setCustomerList("");
      setCustomerListLabels("");
      initAsyncCalls();
    }
  }, [props.parentState.switchAccount]);

  // === API & HANDLERS ===
  const initAsyncCalls = (resetService) => {
    if (resetService) {
      setCustomerList("");
      setCustomerListLabels("");

      ApiManager.getRequest(
        {
          jwt: props.getDecryptedToken(),
        },
        "/service/list"
      ).then(customerServicesListSuccess, errorCallBack);

      return;
    }

    ApiManager.getRequest(
      {
        jwt: props.getDecryptedToken(),
      },
      "/service/list"
    ).then(customerServicesListSuccess, errorCallBack);

    ApiManager.getRequest(
      {
        jwt: props.getDecryptedToken(),
      },
      "/tariff/list"
    ).then(tariffListSuccess, errorCallBack);

    ApiManager.getRequest(
      {
        jwt: props.getDecryptedToken(),
      },
      "/inclusions"
    ).then(inclusionsListSuccess, errorCallBack);

    ApiManager.getRequest(
      {
        jwt: props.getDecryptedToken(),
      },
      "/tariff/product-apps"
    ).then(productAppsSuccess, errorCallBack);
  };

  const errorCallBack = () => {
    if (!componentIsMounted.current) return;
    setShowErrorModal(true);
  };

  const tariffListSuccess = (resolve) => {
    if (!componentIsMounted.current) return;
    setTariffList(resolve.data);
  };

  const customerServicesListSuccess = (resolve) => {
    if (!componentIsMounted.current) return;

    let newCustomerListLabels = {};
    if (resolve.data.status === "OK") {
      resolve.data.data.services.map((item) => {
        newCustomerListLabels[item.billing_id] = item.state === "enabled";
        newCustomerListLabels[item.billing_id + "Disabled"] = false;
        return true;
      });
    }

    setCustomerList(resolve.data);
    setCustomerListLabels(newCustomerListLabels);
  };

  const inclusionsListSuccess = (resolve) => {
    if (!componentIsMounted.current) return;
    setInclusionsList(resolve.data);
  };

  const productAppsSuccess = (resolve) => {
    if (!componentIsMounted.current) return;
    setProductApps(resolve.data);
  };

  // === NOTIFICATION ===
  const addNotification = (inMessage, type) => {
    if (!componentIsMounted.current) {
      return;
    }
    notificationDOMRef.current.addNotification({
      title: "",
      message: inMessage,
      type: type || "success",
      insert: "top",
      container: "top-right",
      animationIn: ["animated", "fadeIn"],
      animationOut: ["animated", "fadeOut"],
      dismiss: { duration: 2000 },
      dismissable: { click: true },
    });
  };

  // === TEMPLATING FUNCTIONS ===
  const inclusionList = () => {
    let listItems = (
      <div className="loading-box pr">
        <div className="loading"></div>
      </div>
    );
    let productAppsList = "";

    if (inclusionsList !== "" && inclusionsList.status === "OK") {
      listItems = inclusionsList.data.inclusions.map((item, index) => {
        let expDate = "";
        let progressBar = "";
        let info = (
          <div className="list__inclusion-inner">
            <div className="list__inner-info--dark fb ver-top-box tl">
              {item.info}
            </div>
          </div>
        );

        if (item.expiration_date !== "") {
          expDate = (
            <div className="list__date fs12">{item.expiration_date}</div>
          );
        }

        if (item.with_bar) {
          progressBar = (
            <div className="list__progress-out">
              <div
                className={`list__progress-inner${
                  item.percentage < 0.2 ? " list__progress-inner--low" : ""
                }`}
                style={{ width: item.percentage * 100 + "%", backgroundColor: item.isWarning && "#FF4D4D" }}
              ></div>
            </div>
          );
          info = (
            <div className="list__inclusion-inner">
              <div
                className="list__inner-info list__inner-info--dark fb ver-top-box tl"
                style={{
                  fontSize:
                    language === "hy" && item.total === "Անսահմանափակ"
                      ? "12px"
                      : "14px",
                }}
              >
                {item.reminder + " " + item.reminder_unit}
              </div>
              <div
                className="list__inner-info ver-top-box tr"
                style={{
                  fontSize:
                    language === "hy" && item.total === "Անսահմանափակ"
                      ? "12px"
                      : "14px",
                }}
              >
                {item.total + " " + item.total_unit}
              </div>
            </div>
          );
        }

        return (
          <li className="list__item" key={index}>
            <div className="list__link pr clear-fix">
              <img
                className="list__img fl db"
                src={item.icon}
                alt={item.label}
              />
              <div className="list__inner">
                <div className="list__title fs14">{item.label}</div>
                {progressBar}
                {info}
                {expDate}
              </div>
            </div>
          </li>
        );
      });

      if (!inclusionsList.data.inclusions.length) {
        listItems = (
          <li className="list__item">
            <div className="list__link">
              {trans(props.trans, "empty.message")}
            </div>
          </li>
        );
      }
    }

    productAppsList = <ProductAppList productApps={productApps} />;

    if (listItems !== "" || productAppsList !== "") {
      listItems = (
        <div className="main-wrapper__list-out">
          <ul className="list list--inclusions">
            {listItems}
            {productAppsList}
          </ul>
        </div>
      );
    }

    if (
      inclusionsList !== "" &&
      (inclusionsList.status === "ERROR" ||
        inclusionsList.status === "NOT_FOUND")
    ) {
      listItems = <p className="error-message">{inclusionsList.message}</p>;
    }

    return (
      <section className="main-wrapper__inclusion-box">
        <h2 className="main-wrapper__sub-title main-wrapper__sub-title--inclusion pr sprite-b move-cursor fb">
          {trans(props.trans, "profile.inclusion.title")}
        </h2>
        {listItems}
      </section>
    );
  };

  const expensesList = () => {
    let progressItems = (
      <div className="loading-box pr">
        {/* <div className="loading"></div> */}
        <div className="list__link"> {trans(props.trans, "empty.message")}</div>
      </div>
    );

    if (
      props.parentState.expenses.message !== "" &&
      props.parentState.expenses.status === "OK"
    ) {
      progressItems = (
        <p className="empty-message">{trans(props.trans, "empty.message")}</p>
      );

      if (props.parentState.expenses.data.records.length) {
        let grouping = groupByKey(
          props.parentState.expenses.data.records,
          "type"
        );
        let groupedPrice = {};
        let totalCount = 0;
        let groupedItems = Object.keys(grouping);

        groupedItems.forEach((item) => {
          // if too many groups, skipping "OTHER" group as in original code
          if (groupedItems.length > 5 && item === "OTHER") {
            return;
          }

          if (!groupedPrice.hasOwnProperty(item)) {
            groupedPrice[item] = {
              count: 0,
              label: "",
              color: "",
              currency: "",
            };
          }

          grouping[item].forEach((groupItem) => {
            groupedPrice[item]["count"] += Number(groupItem["price"]);

            if (groupedPrice[item]["label"] === "") {
              groupedPrice[item]["label"] = groupItem["group_label"];
            }
            if (groupedPrice[item]["color"] === "") {
              groupedPrice[item]["color"] = groupItem["color"];
            }
            if (groupedPrice[item]["currency"] === "") {
              groupedPrice[item]["currency"] = groupItem["currency"];
            }
          });

          totalCount += groupedPrice[item]["count"];
        });

        progressItems = Object.keys(groupedPrice).map((item, index) => {
          let groupItem = groupedPrice[item];

          return (
            <li className="progress-list__item ver-top-box" key={index}>
              <div className="progress-list__circle pr">
                <Circle
                  params={{
                    start: 421,
                    height: 158,
                    width: 158,
                    cx: 79,
                    cy: 79,
                    radius: 67,
                    strokeWidth: 22,
                    fill: "transparent",
                    count: groupItem.count,
                    color: groupItem.color,
                    totalCount: totalCount,
                  }}
                />
                <div
                  className="progress-list__price fb fs20 pr"
                  style={{ color: groupItem.color }}
                >
                  {setComoAfterThirdSymbol(Math.round(groupItem.count)) +
                    " " +
                    groupItem.currency}
                </div>
              </div>
              <h3
                className="progress-list__title fb tu"
                style={{ color: groupItem.color }}
              >
                {groupItem.label}
              </h3>
            </li>
          );
        });

        progressItems = (
          <div className="main-wrapper__progress-box">
            <ul className="progress-list tc">{progressItems}</ul>
          </div>
        );
      }
    }
    if (
      props.parentState.expenses.message === "" &&
      (props.parentState.expenses.status === "ERROR_DIALOG" ||
        props.parentState.expenses.status === "NOT_FOUND")
    ) {
      progressItems = (
        <p className="empty-message">{trans(props.trans, "empty.message")}</p>
      );
    }
    return (
      <section className="main-wrapper__services">
        <div className="main-wrapper__services-title-box pr">
          <Link
            className="main-wrapper__sub-title main-wrapper__sub-title--history db monserrat-medium tl pr sprite-b trans-background"
            to={config.urlPrefix + "profile/history"}
          >
            {trans(props.trans, "profile.progress.title")}
            <span className="main-wrapper__timeline db fb fr sprite-a pr">
              {trans(props.trans, "profile.progress.from.title")}{" "}
              {props.parentState.defaultFromDate}{" "}
              {trans(props.trans, "profile.progress.to.title")}{" "}
              {props.parentState.defaultToDate}
            </span>
          </Link>
        </div>
        {progressItems}
      </section>
    );
  };

  // === TOGGLE SERVICES ===
  const servicesListChangeHandler = (item, stateName) => {
    const checkedValue = item.billing_id;
    const conflictsDescription = item.conflicts_description;

    // Current state for labels
    const currentState = { ...customerListLabels };

    if (item.disable_activation === "1") {
      // means we cannot enable the service; we only can disable
      if (currentState[checkedValue]) {
        // disabling
        setShowConfirmServiceModal(true);
        setConfirmActivate("");
        setConfirmData({
          checkedValue,
          stateName,
          conflictsDescription,
        });
      } else {
        // enabling is not allowed
        setShowAlertServiceModal(true);
        setConfirmActivate("_activate");
      }
    } else if (item.disable_deactivation === "1") {
      // means we cannot disable the service; we only can enable
      if (!currentState[checkedValue]) {
        // enabling
        setShowConfirmServiceModal(true);
        setConfirmActivate("_activate");
        setConfirmData({
          checkedValue,
          stateName,
          conflictsDescription,
        });
      } else {
        // disabling is not allowed
        setShowAlertServiceModal(true);
        setConfirmActivate("");
      }
    } else {
      // no restrictions
      setConfirmData({
        checkedValue,
        stateName,
      });
      doToggleService();
    }
  };

  const doToggleService = () => {
    const { stateName, checkedValue } = confirmData;
    const currentState = { ...customerListLabels };
    const newChecked = !currentState[checkedValue];

    // Toggle
    currentState[checkedValue] = newChecked;
    currentState[checkedValue + "Disabled"] = true;

    // Update local state
    setCustomerListLabels(currentState);
    setShowConfirmServiceModal(false);

    // Call to toggle
    toggleService(stateName, checkedValue, !newChecked);
  };

  const toggleService = (stateName, checkedValue, isChecked) => {
    // if isChecked === true => means we are calling /disable
    // if isChecked === false => means we are calling /enable
    const currentState = { ...customerListLabels };

    if (isChecked) {
      ApiManager.postRequest(
        {
          _token: props.csrf_token.data,
          jwt: props.getDecryptedToken(),
          soc: checkedValue,
        },
        "/service/disable"
      ).then((resolve) => {
        if (!componentIsMounted.current) {
          return;
        }
        currentState[checkedValue + "Disabled"] = false;
        setCustomerListLabels(currentState);

        if (resolve.data.status === "OK") {
          addNotification(resolve.data.message);
          initAsyncCalls(true);
        }

        if (resolve.data.status === "ERROR") {
          addNotification(resolve.data.message, "danger");
          currentState[checkedValue] = false;
          setCustomerListLabels(currentState);
        }
      }, errorCallBack);
    } else {
      ApiManager.postRequest(
        {
          _token: props.csrf_token.data,
          jwt: props.getDecryptedToken(),
          soc: checkedValue,
        },
        "/service/enable"
      ).then((resolve) => {
        if (!componentIsMounted.current) {
          return;
        }
        currentState[checkedValue + "Disabled"] = false;
        setCustomerListLabels(currentState);

        if (resolve.data.status === "OK") {
          addNotification(resolve.data.message);
          initAsyncCalls(true);
        }

        if (resolve.data.status === "ERROR") {
          addNotification(resolve.data.message, "danger");
          currentState[checkedValue] = false;
          setCustomerListLabels(currentState);
        }
      }, errorCallBack);
    }
  };

  const drawCustomerServicesList = (isPaid, title) => {
    if (!customerList.data) return "";

    let result = customerList.data.services.map((item, index) => {
      if (item.paid === isPaid) {
        return ""; // skip
      }

      let url = "";
      if (item.url !== "") {
        url = (
          <a
            className="list__next-btn sprite"
            href={item.url.replace(/\?ref=mobile/, "")}
            target="_blank"
            rel="noopener noreferrer"
          >
            {" "}
          </a>
        );
      }

      return (
        <li className="list__item" key={index}>
          <div className="list__link pr">
            <div className="list__services-first">
              <div className="list__inner-info list__inner-info--dark monserrat-medium">
                {item.name}
              </div>
              <p className="list__inner-info">{item.price_note}</p>
            </div>

            {/* Checking various combinations of disable_activation / disable_deactivation */}
            {((item.disable_activation !== "1" &&
              item.disable_deactivation !== "1") ||
              (item.disable_activation === "0" &&
                item.disable_deactivation === "1") ||
              (item.disable_activation === "1" &&
                item.disable_deactivation === "0") ||
              (item.state === "enabled" && item.is_archived === "1")) && (
              <div className="list__services-second">
                <input
                  className="form__checkbox dn"
                  id={"customer-" + item.billing_id}
                  name={"customer-" + item.billing_id}
                  type="checkbox"
                  checked={customerListLabels[item.billing_id] || false}
                  onChange={() =>
                    servicesListChangeHandler(item, "customerListLabels")
                  }
                  disabled={customerListLabels[item.billing_id + "Disabled"]}
                />
                <label
                  className="form__check-label pa db"
                  htmlFor={"customer-" + item.billing_id}
                ></label>
                {url}
              </div>
            )}
          </div>
        </li>
      );
    });

    if (result.join("") === "") {
      return "";
    } else {
      return (
        <>
          <li className="list__item list__item--title monserrat-medium">
            {title}
          </li>
          {result}
        </>
      );
    }
  };

  const servicesList = () => {
    let result = (
      <div className="loading-box pr">
        <div className="loading"></div>
      </div>
    );

    if (customerList !== "" && customerList.status === "OK") {
      let paidGroup = drawCustomerServicesList(
        false,
        trans(props.trans, "services.customer.paid_title")
      );
      let freeGroup = drawCustomerServicesList(
        true,
        trans(props.trans, "services.customer.free_title")
      );

      if (paidGroup === "" && freeGroup === "") {
        paidGroup = (
          <li className="list__item">
            <div className="list__link">
              {trans(props.trans, "empty.message")}
            </div>
          </li>
        );
      }

      result = (
        <div className="main-wrapper__list-out main-wrapper__list-out--services scroller-block">
          <ul className="list list--double">
            {paidGroup}
            {freeGroup}
          </ul>
        </div>
      );
    }

    if (
      customerList !== "" &&
      (customerList.status === "ERROR" || customerList.status === "NOT_FOUND")
    ) {
      result = <p className="error-message">{customerList.message}</p>;
    }

    return (
      <section className="main-wrapper__services">
        <h2 className="main-wrapper__sub-title main-wrapper__sub-title--services monserrat-medium pr sprite-b move-cursor">
          {trans(props.trans, "services.customer.title")}
        </h2>
        {result}
      </section>
    );
  };

  const tariffPlans = () => {
    let result = (
      <div className="loading-box pr">
        <div className="loading"></div>
      </div>
    );

    if (tariffList !== "" && tariffList.status === "OK") {
      result = (
        <div className="main-wrapper__list-out">
          <ul className="list list--inclusions">
            <li className="list__item">
              <div className="list__link">
                {trans(props.trans, "empty.message")}
              </div>
            </li>
          </ul>
        </div>
      );

      let list = "";

      if (tariffList.data.current) {
        if (
          tariffList.data.current.related_important_inclusions &&
          tariffList.data.current.related_important_inclusions.length
        ) {
          list = tariffList.data.current.related_important_inclusions.map(
            (item, index) => {
              return (
                <li className="list__item" key={index}>
                  <div className="list__link pr clear-fix">
                    <img
                      className="list__img fl db"
                      src={item.icon}
                      alt={item.name}
                    />
                    <div className="list__inner">
                      <div className="list__inner-info ver-top-box tl">
                        {item.name}
                      </div>
                      <div className="list__inner-info list__inner-info--dark fb ver-top-box tr">
                        {setComoAfterThirdSymbol(item.value)}{" "}
                        {item.measurement_unit}
                      </div>
                    </div>
                  </div>
                </li>
              );
            }
          );

          list = (
            <div className="main-wrapper__list-out">
              <ul className="list list--inclusions list--export">{list}</ul>
            </div>
          );
        }

        result = (
          <>
            <a
              className="list__export-btn db monserrat-medium tl pr"
              href={tariffList.data.current.url.replace(/\?ref=mobile/, "")}
              target="_blank"
              rel="noopener noreferrer"
            >
              {tariffList.data.current.name}
              <span className="list__next-btn db sprite"></span>
            </a>
            {list}
          </>
        );
      }
    }

    if (
      tariffList !== "" &&
      (tariffList.status === "ERROR" || tariffList.status === "NOT_FOUND")
    ) {
      result = <p className="error-message">{tariffList.message}</p>;
    }

    return (
      <section className="main-wrapper__services">
        <h2 className="main-wrapper__sub-title main-wrapper__sub-title--package main-wrapper__sub-title--white-bg monserrat-medium pr sprite-b move-cursor">
          {trans(props.trans, "account.tariff.plan_title")}
        </h2>
        {result}
      </section>
    );
  };

  const notificationRender = () => {
    if (!componentIsMounted.current) {
      return null;
    }
    return <ReactNotification ref={notificationDOMRef} />;
  };

  const errorModal = () => {
    if (!showErrorModal) {
      return null;
    }
    return (
      <ErrorModal
        title={trans(props.trans, "error.modal.title")}
        description={trans(props.trans, "error.modal.description")}
        action_text={trans(props.trans, "error.modal.action_text")}
      />
    );
  };

  const confirmToggleServiceModal = () => {
    if (!showConfirmServiceModal || !confirmData) {
      return null;
    }

    let conflictsDescription = "";
    if (
      confirmData.conflictsDescription &&
      confirmData.conflictsDescription !== ""
    ) {
      conflictsDescription = confirmData.conflictsDescription + "<br />";
    }

    return (
      <Modal
        title={trans(props.trans, "services.confirm.toggle.title")}
        htmlDescription={
          conflictsDescription +
          trans(
            props.trans,
            "services.confirm.toggle.description" + confirmActivate
          )
        }
        agreeText={trans(props.trans, "services.confirm.toggle.btn_title")}
        agreeAction={() => doToggleService()}
        showCancelButton={true}
        cancelText={trans(
          props.trans,
          "services.confirm.toggle.cancel_btn_title"
        )}
        cancelAction={() => setShowConfirmServiceModal(false)}
        className="modal--full"
      />
    );
  };

  const alertToggleServiceModal = () => {
    if (!showAlertServiceModal) {
      return null;
    }

    return (
      <Modal
        title={trans(props.trans, "services.alert.toggle.title")}
        description={trans(
          props.trans,
          "services.alert.toggle.description" + confirmActivate
        )}
        agreeText={trans(props.trans, "services.alert.toggle.btn_title")}
        agreeAction={() => setShowAlertServiceModal(false)}
        className="modal--full"
      />
    );
  };

  // Store the sections in an array for DnD (same as original)
  const dndSections = [
    <div className="row-drag-handle" key="1">
      {inclusionList()}
    </div>,
    <div className="row-drag-handle" key="2">
      {servicesList()}
    </div>,
    <div className="row-drag-handle" key="3">
      {tariffPlans()}
    </div>,
  ];

  // Sync updated dnd arrays with local storage on every render
  localStorageSetItem("profileDefaultDnd1", dnd1);
  localStorageSetItem("profileDefaultDnd2", dnd2);
  localStorageSetItem("profileDefaultDnd3", dnd3);

  return (
    <>
      {notificationRender()}

      <div className="main-wrapper__inner-left fl">
        <Container
          orientation="vertical"
          dragHandleSelector=".main-wrapper__sub-title"
          dropPlaceholder={{
            className: "box-drop-preview",
          }}
          groupName="1"
          getChildPayload={(i) => dnd1[i]}
          onDrop={(e) => setDnd1(applyDrag(dnd1, e))}
        >
          {dnd1.map((index) => (
            <Draggable key={index}>{dndSections[index]}</Draggable>
          ))}
        </Container>
      </div>

      <div className="main-wrapper__inner-big">
        {/* <div className="row-drag-handle">{expensesList()}</div> */}

        <div className="main-wrapper__double-list">
          <div className="main-wrapper__double-list-item ver-top-box">
            <Container
              orientation="vertical"
              dragHandleSelector=".main-wrapper__sub-title"
              dropPlaceholder={{
                className: "box-drop-preview",
              }}
              groupName="1"
              getChildPayload={(i) => dnd2[i]}
              onDrop={(e) => setDnd2(applyDrag(dnd2, e))}
            >
              {dnd2.map((index) => (
                <Draggable key={index}>{dndSections[index]}</Draggable>
              ))}
            </Container>
          </div>
          <div className="main-wrapper__double-list-item ver-top-box">
            <Container
              orientation="vertical"
              dragHandleSelector=".main-wrapper__sub-title"
              dropPlaceholder={{
                className: "box-drop-preview",
              }}
              groupName="1"
              getChildPayload={(i) => dnd3[i]}
              onDrop={(e) => setDnd3(applyDrag(dnd3, e))}
            >
              {dnd3.map((index) => (
                <Draggable key={index}>{dndSections[index]}</Draggable>
              ))}
            </Container>
          </div>
        </div>
      </div>

      {errorModal()}
      {alertToggleServiceModal()}
      {confirmToggleServiceModal()}
    </>
  );
}

export default DefaultPage;
